import { render, staticRenderFns } from "./OrganizationDetail.vue?vue&type=template&id=faba9e0c"
import script from "./OrganizationDetail.vue?vue&type=script&lang=js"
export * from "./OrganizationDetail.vue?vue&type=script&lang=js"
import style0 from "./OrganizationDetail.vue?vue&type=style&index=0&id=faba9e0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports